import PartySocket from 'partysocket';

// Realtime sync via the kwis-realtime worker (partyserver on Cloudflare
// Durable Objects). One room per game: the server relays every message to
// all clients except the sender and replays the last game-state snapshot
// to every (re)connecting client.
export const socketService = {
  socket: null,
  listeners: {},
  reconnectCallbacks: [],
  expired: false,

  init(gameId) {
    if (!process.env.VUE_APP_PARTYKIT_HOST) return false;

    this.socket = new PartySocket({
      host: process.env.VUE_APP_PARTYKIT_HOST,
      party: 'dsmtw-game',
      room: gameId
    });

    let wasConnected = false;
    this.socket.addEventListener('open', () => {
      if (wasConnected) this.reconnectCallbacks.forEach(cb => cb());
      wasConnected = true;
    });

    this.socket.addEventListener('message', event => {
      let message;
      try {
        message = JSON.parse(event.data);
      } catch (e) {
        return;
      }
      // The server refuses expired/unknown game sessions: stop reconnecting
      if (message.type === 'session-expired') {
        this.expired = true;
        this.socket.close();
        return;
      }
      (this.listeners[message.type] || []).forEach(cb => cb(message.data));
    });

    this.socket.addEventListener('close', event => {
      // 4001 = the server refused us: game session expired. Stop retrying.
      if (event.code === 4001) {
        this.expired = true;
        this.socket.close();
      }
    });

    return true;
  },

  broadcast(eventName, data = {}) {
    // PartySocket buffers sends while (re)connecting
    this.socket?.send(JSON.stringify({ type: eventName, data }));
    return this;
  },

  listen(eventName, cb) {
    if (!this.listeners[eventName]) this.listeners[eventName] = [];
    this.listeners[eventName].push(cb);
    return this;
  },

  onReconnect(cb) {
    this.reconnectCallbacks.push(cb);
    return this;
  }
};
